import MainLayout from '@layouts/main-layout';

export default {
  page: {
    title: 'Loading page...',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
  components: { MainLayout },
};
